<div class="legend-item-color" [style.background-color]="color"></div>
<span class="legend-item-label">{{ label.key | translate: label.params }}</span>
<ng-container *ngIf="!!valueLabel">
  <span class="legend-item-value-label">{{ valueLabel }}</span>
</ng-container>
